import ThemeManager from '../../../theme/ThemeManager';
import './Navbar.css'; // <-- DODAJ TĘ LINIJKĘ TUTAJ!
export default function NavbarController() {

    document
        .querySelectorAll('[data-scroll]')
        .forEach(link => {

            link.addEventListener('click', event => {

                event.preventDefault();

                const id =
                    link.getAttribute('href');

                const target =
                    document.querySelector(id);

                if (!target)
                    return;

                target.scrollIntoView({

                    behavior: 'smooth',

                    block: 'start'

                });

            });

        });
        const toggle =
    document.querySelector('.navbar__toggle');

const menu =
    document.querySelector('.navbar__menu');

if (toggle && menu) {

    toggle.addEventListener('click', () => {

        menu.classList.toggle('is-open');

    });

}

const button = document.getElementById('theme-toggle');

if (button) {

    updateThemeIcon();

    button.addEventListener('click', () => {

        ThemeManager.toggle();

        updateThemeIcon();

    });

}

function updateThemeIcon() {

    button.textContent =
        ThemeManager.get() === 'dark'
            ? '☀️'
            : '🌙';

}

}
